module.exports = __webpack_public_path__ + "media/images/how_it_works_4-56e21495df730a6f75b5e2356bf27735.png";